import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CartItem } from 'models/IDeliveryOrder'

export interface OrdersState {
  isLoading: boolean
  isAddingToCart: boolean
  cart: CartItem[] | null
  isDeliveryOrderSuccess: boolean | null
  orderId: string | null
  totalPrice: number | null
  customerName: string | null
}

interface UpdateQuantityPayload {
  productId: number
  variantName?: string | null
}

const initialState: OrdersState = {
  isLoading: false,
  isAddingToCart: false,
  cart: null,
  isDeliveryOrderSuccess: null,
  orderId: null,
  totalPrice: null,
  customerName: null,
}

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    apiRequest: (state) => {
      state.isLoading = true
      state.isDeliveryOrderSuccess = false
      state.orderId = null
      state.totalPrice = null
      state.customerName = null
    },
    apiFailure: (state) => {
      state.isLoading = false
      state.isDeliveryOrderSuccess = false
      state.orderId = null
      state.totalPrice = null
      state.customerName = null
    },
    addingToCart: (state) => {
      state.isAddingToCart = true
    },
    addToCart(state, action) {
      const newItem = action.payload.cart
      const currentCart = state.cart || []

      const existingItem = currentCart.find(
        (item) => item.productId === newItem.productId
      )

      if (existingItem) {
        if (existingItem.variantName === newItem.variantName)
          state.cart = currentCart.filter(
            (item) =>
              !(
                item.productId === newItem.productId &&
                item.variantName === newItem.variantName
              )
          )
        else
          state.cart = currentCart.map((item) =>
            item.productId === newItem.productId ? newItem : item
          )
      } else state.cart = [...currentCart, newItem]

      state.isAddingToCart = false
    },
    increaseQuantity(state, action: PayloadAction<UpdateQuantityPayload>) {
      if (state.cart) {
        const { productId, variantName } = action.payload

        const item = state.cart.find(
          (i) => i.productId === productId && i.variantName === variantName
        )

        if (item) item.quantity++
      }
    },
    decreaseQuantity(state, action: PayloadAction<UpdateQuantityPayload>) {
      if (state.cart) {
        const { productId, variantName } = action.payload

        const itemIndex = state.cart.findIndex(
          (i) => i.productId === productId && i.variantName === variantName
        )

        if (itemIndex >= 0) {
          const item = state.cart[itemIndex]

          if (item.quantity > 1) {
            item.quantity--
          } else {
            state.cart.splice(itemIndex, 1)
          }
        }
      }
    },
    checkoutDeliveryOrder(state, action) {
      state.isLoading = false
      state.isDeliveryOrderSuccess = true
      state.cart = null
      state.orderId = action.payload.data.orderId
      state.totalPrice = action.payload.data.totalPrice
      state.customerName = action.payload.data.customerName
    },
  },
})

export const {
  apiRequest,
  apiFailure,
  addingToCart,
  addToCart,
  increaseQuantity,
  decreaseQuantity,
  checkoutDeliveryOrder,
} = ordersSlice.actions
export default ordersSlice.reducer
